module.exports = __webpack_public_path__ + "fonts/CrimsonText-Bold.e3f5f5ee.eot";